import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { apiPost } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) {
        navigate("/", { replace: true });
        return;
      }
      const sessionId = decodeURIComponent(m[1]);
      try {
        const data = await apiPost("/auth/session", { session_id: sessionId });
        setUser({ ...data.user, loyalty: { paid_count: 0, next_reward_at: 5, progress_pct: 0, reward_ready: false } });
        // Strip hash and go to account
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        navigate("/account", { replace: true, state: { user: data.user, isNew: data.is_new_user } });
      } catch (e) {
        navigate("/?auth=error", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-2 border-sky-500 border-t-transparent rounded-full animate-spin" />
        <p className="text-gray-400 text-sm tracking-widest uppercase">Signing you in...</p>
      </div>
    </div>
  );
}
